<nb-layout>
    <nb-layout-column>
     
                <h3>Add new painting </h3>
          
                <form [formGroup]="fg" (ngSubmit)="onSubmit()">

                        Name: <input nbInput type="text" formControlName="name">
                        Year: <input nbInput type="number" formControlName="year">
                        Description: <input nbInput type="string" formControlName="description">
                        Dimensions: <input nbInput type="string" formControlName="dimensions">

                        Available:
                        <nb-select class="select" formControlName="available" >
                            <nb-option value="yes">yes</nb-option>
                            <nb-option value="no">no</nb-option>
                        </nb-select> 
                        <!-- <input nbInput type="string" formControlName="available"> -->
                        
                        Choose image: <input nbInput formControlName="pImage" type="file" (change)="onFileSelected($event)" />

                    <button nbButton size="small" type="submit" [disabled]="fg.invalid">Add</button>

                    <p>{{nm}}</p>
                    <!-- <img style='width:200px'src="http://localhost:3100/uploads/{{nm}}" alt=""> -->
                </form>
        
    </nb-layout-column>
</nb-layout>